import { BasePasswordInput } from "../../../Inputs/BasePasswordInput/index.js";
import { useTranslation } from "../../../../../customHooks/useTranslation/index.js";
import { Flex } from "waapi/waap-ui/components/Flex/Flex.js";
import { ITheme } from "waapi/waap-ui/components/Theme/Theme.types.js";
import { ICONSAX_SIZE } from "waapi/waap-ui/components/Iconsax/Iconsax.types.js";
import { InfoCircleLinear } from "waapi/waap-ui/components/Iconsax/InfoCircleLinear.js";
import { Text } from "waapi/waap-ui/components/Text/Text.js";
import { TextSize } from "waapi/waap-ui/components/Text/Text.types.js";
import { Field } from "formik";
import { useTheme } from "styled-components";
import { PasswordInputProps } from "./types.js";
import { passwordInputErrorMap } from "./validation.js";

export const PasswordInput = ({ formState }: PasswordInputProps): JSX.Element => {
    const theme = useTheme() as ITheme;
    const { t, translations } = useTranslation();

    const passwordInputErrors = passwordInputErrorMap({ t, translations });

    return (
        <Field name="password">
            {({ field, meta }) => (
                <Flex direction="column" gap="4">
                    <BasePasswordInput
                        {...field}
                        labelInfos={{ text: t(translations.forms.auth.password.label()), color: theme.grayscale.white }}
                        feedback={
                            meta.touched && meta.error
                                ? { type: "error", textColor: theme.grayscale.white, children: passwordInputErrors[meta.error] }
                                : undefined
                        }
                        value={formState.values.password}
                        disabled={formState.isSubmitting}
                        placeholder={t(translations.forms.auth.password.placeholder())}
                        status={meta.error ? "error" : undefined}
                    />
                    {!meta.touched && !meta.error && (
                        <Flex gap="4" align="center">
                            <InfoCircleLinear size={ICONSAX_SIZE.SMALL} color={theme.colors.primary[100]} />
                            <Text size={TextSize["XX-SMALL"]} color={theme.grayscale.white}>
                                {t(translations.forms.auth.password.feedback.help.requirements())}
                            </Text>
                        </Flex>
                    )}
                </Flex>
            )}
        </Field>
    );
};
